/*
 Detect editor for click-to-component
 Set NX_REACT_APP_EDITOR in .env to override: 'cursor', 'vscode', 'webstorm', or 'intellij'
 */
export const getEditor = () => {
  const preferredEditor = process.env.NX_REACT_APP_EDITOR;

  if (preferredEditor) return preferredEditor;

  if (typeof navigator === 'undefined') return undefined;
  const userAgent = navigator.userAgent.toLowerCase();

  if (userAgent.includes('cursor')) return 'cursor';
  if (userAgent.includes('vscode-insiders')) return 'vscode-insiders';
  if (userAgent.includes('webstorm')) return 'webstorm';
  if (userAgent.includes('intellij')) return 'intellij';
  return 'vscode';
};
